<template>
	<div>
		<div style="width: 100%;" class="d-flex pt-3">
			<div style="width: 33%;">
				<div style="width: 100%;" class="d-flex a-center">
					<div style="width:20%;font-size: 14px;text-align: right;padding-right: 10px;">* 姓名</div>
					<el-input v-model="form.name" placeholder="姓名" size="mini" :disabled="true"></el-input>
				</div>
				<div style="width: 100%;margin-top: 30px;" class="d-flex a-center">
					<div style="width:17%;font-size: 14px;text-align: right;padding-right: 18px;">性别</div>
					<el-button type="primary" size="mini">{{form.xb}}</el-button>
				</div>
				<div style="width: 100%;margin-top: 30px;" class="d-flex a-center">
					<div style="width:20%;font-size: 14px;text-align: right;padding-right: 10px;">座机</div>
					<el-input v-model="form.zj" size="mini" :disabled="true"></el-input>
				</div>
				<div style="width: 100%;margin-top: 30px;" class="d-flex a-center">
					<div style="width:20%;font-size: 14px;text-align: right;padding-right: 10px;">* 登录账号</div>
					<el-input v-model="form.username" placeholder="姓名" size="mini" :disabled="true"></el-input>
				</div>
				<div style="width: 100%;margin-top: 30px;" class="d-flex a-center">
					<div style="width:20%;font-size: 14px;text-align: right;padding-right: 10px;">身份证号</div>
					<el-input v-model="form.sfz" size="mini" :disabled="true"></el-input>
				</div>
				<div style="width: 100%;margin-top: 30px;" class="d-flex a-center">
					<div style="width:20%;font-size: 14px;text-align: right;padding-right: 10px;">邮箱</div>
					<el-input v-model="form.email" size="mini" :disabled="true"></el-input>
				</div>
				<div style="width: 100%;margin-top: 30px;" class="d-flex a-center">
					<div style="width:20%;font-size: 14px;text-align: right;padding-right: 10px;">* 登录密码</div>
					<el-input v-model="form.password" placeholder="姓名" size="mini" :disabled="true"></el-input>
				</div>
				<div style="width: 100%;margin-top: 30px;" class="d-flex a-center">
					<div style="width:20%;font-size: 14px;text-align: right;padding-right: 10px;">手机</div>
					<el-input v-model="form.phone" size="mini" :disabled="true"></el-input>
				</div>
				<div style="width: 100%;margin-top: 30px;" class="d-flex a-center">
					<div style="width:17%;font-size: 14px;text-align: right;padding-right: 10px;">所属部门</div>
					<el-button type="success" size="mini">{{form.role.name}}</el-button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { mapState } from 'vuex';
	export default {
		data() {
			return {
				form:{},
			}
		},
		computed: {
			...mapState({
				user: state => state.user.user
			})
		},
		mounted() {
			this.form = this.user
			console.log(this.form)
		},
		methods: {
		},
	}
</script>

<style>
	.j-center{
		justify-content: center;
	}
	.a-center{
		align-items: center;
	}
	.j-j{
		flex-flow: column;
	}
</style>
